export enum SearchErrorEnum {
    None = 0,
    NotFound = 1
}